import React, { useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import {
  FormArraySelectField,
  FormArrayTextField,
} from "../../../../../partials/content/Forms/FormField";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Table } from "react-bootstrap";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";
import { DialogActions } from "@material-ui/core";
function OutletCashAccountFormContent({ outletID = 0 }) {
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  return (
    <React.Fragment>
      <FieldArray name="outletCashAccount">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                {values.outletCashAccount &&
                values.outletCashAccount.length > 0 ? (
                  <button
                    type="submit"
                    className="btn btn-success btn-sm btn-pill btn-bold"
                  >
                    <i className="fas fa-save"></i>
                    Save
                  </button>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.outletCashAccount &&
                    values.outletCashAccount.length > 0 ? (
                      <thead className="text-center">
                        <th style={{ width: "45%" }}>Account Title</th>
                        <th style={{ width: "20%" }}>Payment Method</th>
                        <th style={{ width: "30%" }}>Cash Account</th>
                        <th>Actions</th>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.outletCashAccount &&
                      values.outletCashAccount.length > 0 ? (
                        values.outletCashAccount.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="outletCashAccount"
                                  index={index}
                                  propName="cashTitle"
                                  margin="none"
                                  placeholder="Hint: Add Title such as Cash, Debit or Credit Card Bank XXX, etc"
                                />
                              </td>
                              <td>
                                <FormArraySelectField
                                  arrayPropName="outletCashAccount"
                                  propName="payMethod"
                                  index={index}
                                  margin="none"
                                  options={[
                                    { label: "Cash", value: 1 },
                                    { label: "Debit Card", value: 2 },
                                    { label: "Credit Card", value: 3 },
                                  ]}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="outletCashAccount"
                                  index={index}
                                  margin="none"
                                  propName="accountName"
                                  readonly
                                  searchButton
                                  onSearchClick={() => {
                                    setItemIndex(index);
                                    setOpenSearchGlAccount(true);
                                  }}
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                <BootstrapTooltip
                                  title={
                                    item.deleteInd
                                      ? "Undo Delete"
                                      : "Delete POS Cash Account Item"
                                  }
                                >
                                  <button
                                    type="button"
                                    className={`btn btn-icon btn-label-${
                                      item.deleteInd ? "warning" : "danger"
                                    } btn-md btn-circle mx-1`}
                                    onClick={() => {
                                      if (item.ID > 0) {
                                        setFieldValue(
                                          `outletCashAccount[${index}].deleteInd`,
                                          !item.deleteInd
                                        );
                                      } else {
                                        remove(index);
                                      }
                                    }}
                                  >
                                    {item.deleteInd ? (
                                      <i className="fas fa-undo-alt"></i>
                                    ) : (
                                      <i className="fas fa-trash-alt"></i>
                                    )}
                                  </button>
                                </BootstrapTooltip>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td className="text-center py-3" colSpan="4">
                            <Illustration
                              imageSource="INVIFO Payment.png"
                              guidance="You don't have any POS Cash Account items for this outlet yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="text-center py-3" colSpan="4">
                          <button
                            type="button"
                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                            onClick={() => {
                              push({
                                ID: 0,
                                outletID,
                                cashTitle: "",
                                payMethod: 1,
                                accountID: 0,
                                accountName: "",
                                deleteInd: false,
                              });
                            }}
                          >
                            <i className="fas fa-plus-circle"></i>
                            Add POS Cash Account
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={1}
          onSelectGlAccount={(account) => {
            setFieldValue(
              `outletCashAccount[${itemIndex}].accountID`,
              account.ID
            );
            setFieldValue(
              `outletCashAccount[${itemIndex}].accountName`,
              account.accountName
            );
            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default OutletCashAccountFormContent;
